module.exports = __webpack_public_path__ + "static/img/duoyun_baitian.f193dbbf.png";